export function scroll(node, config) {
    const { api, tick = () => {
        return new Promise((r) => {
            requestAnimationFrame(() => {
                r();
            });
        });
    }, } = config;
    const scroll = api.getReactiveState().scroll;
    const dataAttrKeys = {
        card: "data-drag-item",
        column: `data-column-header`,
        row: `data-row-header`,
    };
    scroll?.subscribe(v => {
        if (v) {
            const { to, id, options } = v;
            scrollTo(`[${dataAttrKeys[to]}="${id}"]`, options)
                .then(ready => {
                if (ready) {
                    scroll.set(null);
                }
            })
                .catch();
        }
    });
    function scrollTo(selector, options) {
        return new Promise(res => {
            tick().then(() => {
                const el = node.querySelector(selector);
                if (el) {
                    el.scrollIntoView(options || {
                        behavior: "smooth",
                        block: "nearest",
                        inline: "nearest",
                    });
                    res(true);
                }
                res(false);
            });
        });
    }
}
//# sourceMappingURL=scroll.js.map